import { jsx as n } from "react/jsx-runtime";
import * as l from "@radix-ui/react-separator";
import { cva as h } from "class-variance-authority";
import * as s from "react";
import { cn as m } from "../../utils.js";
const c = h("shrink-0 rounded-full bg-onSurface-300", {
  variants: {
    orientation: {
      horizontal: "w-full",
      vertical: "h-full"
    },
    weight: {
      light: "",
      medium: "",
      heavy: ""
    }
  },
  compoundVariants: [
    { orientation: "horizontal", weight: "light", class: "h-px" },
    { orientation: "horizontal", weight: "medium", class: "h-0.25" },
    { orientation: "horizontal", weight: "heavy", class: "h-[3px]" },
    { orientation: "vertical", weight: "light", class: "w-px" },
    { orientation: "vertical", weight: "medium", class: "w-0.25" },
    { orientation: "vertical", weight: "heavy", class: "w-[3px]" }
  ],
  defaultVariants: {
    orientation: "horizontal",
    weight: "light"
  }
}), g = s.forwardRef(
  ({
    className: t,
    orientation: i = "horizontal",
    weight: o = "light",
    decorative: a = !0,
    ...r
  }, e) => /* @__PURE__ */ n(
    l.Root,
    {
      ref: e,
      decorative: a,
      orientation: i || "horizontal",
      className: m(c({ orientation: i, weight: o }), t),
      ...r
    }
  )
);
g.displayName = "Divider";
export {
  g as Divider
};
